

export const ktronixTenant = {
  name: 'ktronix',
  properties: {
    // Primary colors
    '--primary': '#004C99',
    '--secondary': '#707070',
    '--tertiary': '#004C99',
    '--quarter': '#004C99',
    '--error': 'red',
    '--nav-bar': '#fff',

    /* Buttons */
    // Primary
    '--color-button-primary': '#0056a6',
    '--bg-color-button-primary': '#fff',
    '--hover-color-button-primary': '#707070',
    '--hover-bg-color-button-primary': '#fff',
    // Secondary
    '--color-button-secondary': '#fff',
    '--bg-color-button-secondary': '#004C99',
    '--hover-color-button-secondary': '#fff',
    '--bg-hover-color-button-secondary': '#707070',
    // Tertiary
    '--color-button-tertiary': '#fff',
    '--bg-color-button-tertiary': '#0056a6',
    '--hover-color-button-tertiary': '#fff',
    '--bg-hover-color-button-tertiary': '#707070',

    // Forms
    '--color-input-valid': '#004c99',

    // Fonts
    '--primary-semibold-font-family': 'HelveticaNeueBold',
    '--font-family-secondary': `'Barlow', sans-serif`,
    '--font-family-secondary-medium': `'Barlow', sans-serif`,

    // Header
    '--background-header': '#fff',
    '--color-breadcrumb': '#004590',
    '--color-breadcrumb-sucess': '#0056a6',
    '--logo': 'url(../../../../assets/images/tenants/ktronix/logo.png)',

    // Footer
    '--footer-color': '#fff',

    // SOAT
    '--color-tittle-h2': 'var(--primary)',
    '--color-tittle-h3': 'var(--primary)',
  }
};
